// extracted by mini-css-extract-plugin
module.exports = {"rating-resume":"ProfileRating_rating-resume__bnxcO","rating__title":"ProfileRating_rating__title__J5Mwo","rating__list":"ProfileRating_rating__list__2iDk1"};